import { Link } from "react-router-dom";
import { SERVICES } from "@/lib/data";
import { Check, ArrowRight } from "lucide-react";

export default function ServicesPage() {
  return (
    <>
      <section className="pt-28 md:pt-36 pb-12 md:pb-16 border-b border-damita-border relative overflow-hidden">
        <div className="absolute inset-0 -z-10 blueprint-bg opacity-50" />
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
          <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-damita-blue mb-6 flex items-center gap-3">
            <span className="w-8 tick-line" /> Service Excellence
          </div>
          <div className="grid grid-cols-12 gap-6 lg:gap-12 items-end">
            <h1 className="col-span-12 lg:col-span-8 font-display font-black text-4xl md:text-6xl lg:text-[88px] leading-[0.95] tracking-tighter">
              Our <span className="text-damita-blue">services.</span>
            </h1>
            <p className="col-span-12 lg:col-span-4 text-base md:text-lg leading-relaxed text-damita-ink2">
              From planning to long-term lifecycle maintenance, our certified engineering
              team keeps your power assets optimal, efficient and safe.
            </p>
          </div>
        </div>
      </section>

      <section data-testid="services-section" className="border-b border-damita-border bg-damita-blue text-white">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-14 md:py-20">
          <div className="grid grid-cols-12 gap-px bg-white/20 border border-white/20">
            {SERVICES.map((s) => (
              <div
                key={s.code}
                data-testid={`service-${s.code}`}
                className="col-span-12 md:col-span-6 lg:col-span-4 bg-damita-blue p-6 md:p-8"
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="font-mono text-xs uppercase tracking-[0.22em] text-damita-yellow">/ {s.code}</span>
                  <span className="w-3 h-3 bg-damita-yellow" />
                </div>
                <h3 className="font-display font-bold text-2xl tracking-tight mb-4">{s.title}</h3>
                <p className="text-sm leading-relaxed text-blue-100 mb-6">{s.body}</p>
                <ul className="space-y-3 border-t border-white/20 pt-5">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-3 text-sm">
                      <Check size={16} className="text-damita-yellow mt-0.5 shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-b border-damita-border">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-14 md:py-20 grid grid-cols-12 gap-6 items-center">
          <div className="col-span-12 lg:col-span-8">
            <h2 className="font-display font-black text-3xl md:text-4xl lg:text-5xl tracking-tighter leading-[0.95]">
              Concept to commissioning.<br />
              <span className="text-damita-blue">All under one contract.</span>
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-4 flex">
            <Link
              data-testid="services-cta-contact"
              to="/contact"
              className="inline-flex items-center justify-between gap-3 bg-damita-blue text-white px-6 py-4 font-semibold hover:bg-damita-blueHover transition-all btn-press w-full"
            >
              Talk to our engineers
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
